<template>
  <div :class="{'operation-form': true, 'operation-form--reverse-stack': isConfigurationForm}">
    <HeaderBar :modifiers="headerModifiers">
      <SkeletonElement
        v-if="!isConfigurationForm"
        :width="100"
      />
      <template
        #right
      >
        <SkeletonElement :width="70" />
        <SkeletonElement :width="70" />
      </template>
    </HeaderBar>

    <div :class="{'operation-form__content': !isConfigurationForm}">
      <OperationFormSectionSkeleton
        v-for="section in totalSections"
        :key="section"
        :modifiers="contentModifiers"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import HeaderBar from '@/components/generic/header_bar.vue';
import SkeletonElement from '@/components/generic/skeleton_element.vue';
import OperationFormSectionSkeleton from '@/components/operations/form/operation_form_section_skeleton.vue';

const props = defineProps({
  isConfigurationForm: { type: Boolean, default: false },
  totalSections: { type: Number, default: 2 }
});

const headerModifiers = computed(() => {
  return props.isConfigurationForm ? ['form', 'no-margin-x', 'padding', 'margin-top', 'full-max-width', 'default', 'right'] : ['form', 'transparent'];
});

const contentModifiers = computed(() => {
  return props.isConfigurationForm ? ['no-margin', 'full-max-width', 'responsive', 'default', 'border-bottom'] : [];
});
</script>
